<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbExpenses',
  components: {},
}
</script>
